import {useSelector} from 'react-redux'

import {usePostSlotRelease} from '../../../../../common/react-query/hooks/mutations/usePostSlotRelease'
import type {AppState} from '../../../../../Root.store'

interface SlotReleaseParams {
  externalReference: string
  plantId: string
  materialNumber: string
  onSuccess?: () => void
}

export const useSlotRelease = () => {
  const {mutate: postSlotRelease, isLoading, isError, isSuccess} = usePostSlotRelease()
  const userCountry = useSelector((state: AppState) => state.userProfile.userProfile?.country || '')

  const releaseSlot = ({
    externalReference,
    plantId,
    materialNumber,
    onSuccess
  }: SlotReleaseParams) => {
    const payload = {
      country: userCountry,
      externalReference,
      applicationId: 'hub',
      plantId,
      materialNumber,
      userId: ''
    }

    postSlotRelease({...payload}, {onSuccess})
  }

  return {
    releaseSlot,
    isLoading,
    isError,
    isSuccess
  }
}
